export const SLIDE_WIDTH = 430;
export const SLIDE_HEIGHT = 644;
